<template>
  <div
    id="app"
    :class="{'slide-in-left':indexSlide}"
    v-cloak
    @touchmove.capture="tmove"
    @touchstart.capture="tstart"
  >
    <div class="index-slide-wrapper" v-if="indexSlide">
      <index-slide></index-slide>
    </div>
    <div class="slide-fixed-shadow" v-if="indexSlide" @touchend="closeMenu"></div>
    <div class="main-wrapper">
      <div class="syth">
        <a href="https://m.mnr.gov.cn/zt/dj/xxgcd20d/"> 
          <img style="width: 100%;height: auto;border: none;display: block;" src="../static/img/zrzyb20d.png">
        </a>
      </div>
      <div class="header-hei">
        <common-header></common-header>
      </div>

      <div class="view-content" id="main-content">
        <nav-header v-if="!$route.meta.navFlag"></nav-header>
        <transition name="slide-fade">
          <router-view class="minheight"/>
        </transition>
        <common-footer></common-footer>
      </div>
    </div>
  </div>
</template>

<script>
import commonHeader from "@/components/common/header";
import commonFooter from "@/components/common/footer";
import indexSlide from "@/components/common/indexSlide";
import navHeader from "@/components/common/nav.vue";
import { userApi } from "./api/user.js";
import { mapActions, mapGetters } from "vuex";
import {} from "vuex";
export default {
  name: "App",
  data() {
    return {
      path:''
    };
  },
  computed: {
    ...mapGetters(["indexSlide"])
  },
  mounted() {
    // userApi.getMenu({ id: 1 }).then(() => {
    //   console.log(1);
    // });
    //  userApi.postMenu({ id: 1 }).then(() => {
    // });
    this.path = this.$route.path;
  },
  methods: {
    ...mapActions(["openMenu", "closeMenu", "tstart", "tmove", "setSearch"])
  },
  components: {
    commonHeader,
    navHeader,
    indexSlide,
    commonFooter
  },
  watch: {
    $route(newUrl, oldUrl) {
      if (newUrl.fullPath != oldUrl.query.nowUrl) {
        this.setSearch("");
      }
    },
    $route(to,from){
          this.path = to.path
      }
  }
};
</script>

<style lang="less">
@import "./common/minix.less";
#app {
  height: 100%;
  transition: -webkit-transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out;
  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;
  width: 100%;
  max-width: 100%;
}

// .slide-fade-enter-active {
//   transition: all 0.5s ease;
// }
// .slide-fade-leave-active {
//   transition: all 0s cubic-bezier(1, 0.5, 0.8, 1);
// }
// .slide-fade-enter {
//   transform: translateX(100%);
//   opacity: 0;
// }
// .slide-fade-leave-to {
//   transform: translateX(-100%);
//   opacity: 0;
// }
[v-cloak] {
  display: none !important;
}
.header-hei {
  height: 100 / @rem;
  // position: fixed;
  // width: 100%;
  // top: 0;
  // left: 0;
  z-index: 10;
}
.minheight {
  min-height: 600 / @rem;
}
.main-wrapper {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  height: 100%;
  height: inherit;
  display: flex;
  flex-direction: column;
}
.view-content {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  flex: 1;
  overflow-y: auto;
  // padding-top: 100 / @rem;
  background: #f2f2f2;
}
.slide-fixed-shadow {
  position: fixed;
  top: 100 / @rem;
  left: 0;
  right: 0;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 10;
  overflow: hidden;
}
.index-slide-wrapper {
  right: 0;
  margin-left: 0;
  margin-right: -400 / @rem;
  opacity: 1;
  position: absolute;
  top: 0;
  transition: all 0.3s;
  width: 400 / @rem;
  z-index: 10;
  min-width: auto;
  padding: 0;
  overflow: hidden;
  height: 100%;
  height: inherit;
}
.slide-in-left {
  -webkit-transform: translate3d(-400 / @rem, 0, 0);
  transform: translate3d(-400 / @rem, 0, 0);
}
.viewer-button {
  height: 150 / @rem;
  right: -75 / @rem;
  top: -75 / @rem;
  width: 150 / @rem;
}
.viewer-button::before {
  background: none;
  content: "×";
  bottom: 30 / @rem;
  left: 30 / @rem;
  color: #fff;
  font-size: 50 / @rem;
}

.viewer-button {
  height: 150 / @rem!important;
  right: -75 / @rem!important;
  top: -75 / @rem!important;
  width: 150 / @rem!important;
}
.viewer-button::before {
  background: none !important;
  content: "×" !important;
  bottom: 30 / @rem!important;
  left: 30 / @rem!important;
  color: #fff !important;
  font-size: 50 / @rem!important;
}
.zhihui{
  filter:grayscale(.95);
    -webkit-filter:grayscale(.95);

    filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
    filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=.95 );
}
</style>



// WEBPACK FOOTER //
// src/App.vue